import { animate, style, transition, trigger } from '@angular/animations';

import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InteractiveListItemComponent } from '../interactive-list-item/interactive-list-item.component';

export interface CustomContextMenuItem {
  id: string;
  text: string;
  icon?: string;
  isSvgIcon?: boolean;
  disabled?: boolean;
  divider?: boolean;
  badge?: string | number;
  data?: any;
  color?: string;
  func?: (data?: any) => void;
  submenu?: CustomContextMenuItem[];
  onMouseEnter?: (data?: any) => void;
  onMouseLeave?: (data?: any) => void;
}

@Component({
  selector: 'app-custom-context-menu',
  templateUrl: './custom-context-menu.component.html',
  styleUrls: ['./custom-context-menu.component.scss'],
  standalone: true,
  imports: [InteractiveListItemComponent, TranslateModule], // Added TranslateModule
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95) translateY(-10px)' }),
        animate('100ms ease-out', style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
      ]),
      transition(':leave', [animate('75ms ease-in', style({ opacity: 0, transform: 'scale(0.95) translateY(-10px)' }))]),
    ]),
  ],
})
export class CustomContextMenuComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() menuItems: CustomContextMenuItem[] = [];
  @Output() itemSelected = new EventEmitter<{ actionId: string; data?: any }>();
  @Output() menuClosed = new EventEmitter<void>();

  history: CustomContextMenuItem[][] = [];
  activeMenuItems: CustomContextMenuItem[] = [];

  ngOnInit() {
    this.activeMenuItems = [...this.menuItems];
  }

  onItemClicked(item: CustomContextMenuItem): void {
    if (item.disabled) {
      return;
    }
    if (item.submenu && item.submenu.length > 0) {
      this.history.push([...this.activeMenuItems]);
      this.activeMenuItems = [...item.submenu];
      this.cdr.markForCheck();
      return;
    }
    if (item.func) {
      item.func(item.data);
    }
    this.itemSelected.emit({ actionId: item.id, data: item.data });
  }

  goBack(): void {
    if (this.history.length > 0) {
      this.activeMenuItems = this.history.pop() || [];
      this.cdr.markForCheck();
    }
  }
}
